

import React from 'react';

import RequestProvider from '../../RequestProvider';
import WelcomeModalComponent from '../components/WelcomeGuestModal';
import { loginApi, loginAnonymousUserApi } from '../api';

export default function WelcomeGuest(props) {
  return (
    <RequestProvider
      requests={{
        loginRequest: loginApi(),
        loginAnonymousUserRequest: loginAnonymousUserApi()
      }}>

      {({ loginRequest, loginAnonymousUserRequest }) =>
      <WelcomeModalComponent
        loginRequest={loginRequest}
        loginAnonymousUserRequest={loginAnonymousUserRequest}
        {...props} />}


    </RequestProvider>);

}